import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  ButtonBase,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Theme,
  Typography,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from '@mui/icons-material/Search';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';

import { filter, isUndefined, union, ceil } from 'lodash';
import { DeviceType, WebSiteContext } from '../orbit-context';
import ZTree from './component/zTree';
import './calculators.css';
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
// import { TabPanel } from '../components';
import { IvymobiTabs } from '../components/IvymobiTabs';
import SelectionItem from './component/selectionItem';
import _ from 'lodash';
import { el } from 'date-fns/locale';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import ControlPanel from './component/controlPanel';
import OptionControlPanel from './component/optionControlPanel';

import { getRobotListAction, getCalculartorAction, getCalculatorRatedAction } from '@ivymobi/orbit-core/business/productCenter';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'row',
  },
  calculatorContainer: {

  },
  calPages: {
    margin: '0 auto',
    marginTop: '20px',
  },
  calwbg: {
    backgroundColor: '#fff',
    marginTop: '15px',
    padding: '12px',
    borderRadius: '2px',
  },
  imageButton: {
    position: 'relative',
    width: '80px',
    height: '100px',
    marginLeft: '20px',
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  imageMarked: {},
  imageTitle: {},
  focusVisible: {},
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },


}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

export const RobotCalculatorView = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const webInfo = useContext(WebSiteContext);
  const deviceType = useContext(DeviceType);
  const [showPop,setShowPop] = useState(false)
  // tab栏
  const [value, setValue] = useState('one');
  // tab对应的说明图片
  const [activeValue, setActiveValue] = useState({url: '/images/vertical_explain.jpg'});
  // 切换结果
  const [activeResult, setActiveResult] = useState('one');
  // 图片弹框开关
  const [open, setOpen] = useState(false);
  // 机器人型号列表
  const [robotList, setRobotList] = useState([]);
  // 当前选择的机器人型号
  const [selectValue, setSelectValue] = useState(undefined);

  // 输入产品数据
  const [inputObj, setInputObj] = useState<any>({
    inputValue1: '',
    inputValue2: '',
    inputValue3: '',
    inputValue4: '',
    inputValue4_1: '',
    inputValue4_2: '',
    inputValue5: '',
    inputValue6: '',
    inputValue7: '',
    inputValue8: '',
    inputValue8_1: '',
    inputValue8_2: '',
  });

  // 计算结果额定数据
  const [ratedObj, setRatedObj] = useState({
    ratedValue1: 0,
    ratedValue2: 0,
    ratedValue3: 0,
    ratedValue4: 0,
    ratedValue5: 0,
  });

  // 计算结果实际数据
  const [actualObj, setActualObj] = useState({
    actualValue1: 0,
    actualValue2: 0,
    actualValue3: 0,
    actualValue4: 0,
    actualValue5: 0,
  });

  // 监听tab栏
  useEffect(() => {
    // const oneObj = {
    //   url: '/images/vertical_explain.jpg',
    // };
    // const twoObj = {
    //   url: '/images/horizon_explain.jpg',
    // };
    // value === 'one' ? setActiveValue(oneObj) : setActiveValue(twoObj);
  }, [value]);
  // 监听tab切换获取机器人型号
  useEffect(() => {
    const robotindex = value === 'two' ? '0' : '1';
    const robotArray = new Promise((resolve) => {
      resolve(dispatch(getRobotListAction({user:{token:null, user:null}, tenant:{}, robotIndex: robotindex})));
    });
    robotArray.then((res: string[]) => {
      setRobotList(res);
    });
  }, [value]);
  
  useEffect(()=>{

  
    props.setTitle("产品计算器")
 
    props.setParents([{ to:'/robot',name:'机器人'}])
  },[])
  // 获取计算额定数据，计算结果  --------------选择机器人型号不清空数据--------------
  useEffect(() => {
    // if (isUndefined(selectValue))
    //   return;
    // 重置并切换说明和计算结果数据
    const oneObj = {
      url: '/images/vertical_explain.jpg',
    };
    const twoObj = {
      url: '/images/horizon_explain.jpg',
    };
    value === 'one' ? setActiveValue(oneObj) : setActiveValue(twoObj);
    // 清空数据操作（输入 输出）
    setInputObj({inputValue1: '', inputValue2: '', inputValue3: '', inputValue4: '', inputValue4_1: '', inputValue4_2: '', inputValue5: '', inputValue6: '', inputValue7: '', inputValue8: '', inputValue8_1: '', inputValue8_2: ''});
    setRatedObj({ratedValue1: 0, ratedValue2: 0, ratedValue3: 0, ratedValue4: 0, ratedValue5: 0});
    setActualObj({actualValue1: 0, actualValue2: 0, actualValue3: 0, actualValue4: 0, actualValue5: 0});
    // 切换计算结果显示
    setActiveResult(value);

    // const result = new Promise((resolve) => {
    //   resolve(dispatch(getCalculartorAction({user: {token: null, user: null}, tenant: {}, calculatorVal: selectValue})));
    // });
    // result.then((res: string[]) => {

    // });
  }, [value]);

  // tab栏切换
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectValue(undefined);
  };
  // 图片弹框
  const handleClickOpen = () => {
    setOpen(true);
  };
  // 关闭图片弹框
  const handleClose = () => {
    setOpen(false);
  };
  // 选择机器人型号
  const handleSelect = async(e) => {
    setSelectValue(e.target.textContent);
    console.log('-------e.target.textContent');
    console.log(e.target.textContent);
    const params = {
      robotIndex: value === 'two' ? '0' : '1',
    };
    const res = await dispatch(getCalculatorRatedAction({user: {token: null, user: null}, tenant: {}, calculatorVal: e.target.textContent, params: params}));
    if (value === 'one') {
      setRatedObj({...ratedObj, ratedValue1: res[0]['specifiedInertia'], ratedValue2: res[0]['specifiedWeight']});
      // setActualObj({...actualObj, actualValue1: res[1]['inertia'], actualValue2: res[1]['weight'] });
    } else {
      setRatedObj({...ratedObj, ratedValue3: res[0]['specifiedJ5'], ratedValue4: res[0]['specifiedJ6'], ratedValue5: res[0]['specifiedWeight']});
      // setActualObj({...actualObj, actualValue3: res[1]['J5_moment'], actualValue4: res[1]['J6_Inertia'], actualValue5: res[1]['weight']});
    }
  };
  // 提交
  const handleSubmit = async () => {
    const paramsPublic = {
      // robotIndex: value === 'two' ? 1 : 0,
      tongs_length: inputObj.inputValue1 || 0,
      tongs_width: inputObj.inputValue2 || 0,
      tongs_weight: inputObj.inputValue3 || 0,
      tongs_heart_length: inputObj.inputValue4 || 0,
      workpiece_length: inputObj.inputValue5 || 0,
      workpiece_width: inputObj.inputValue6 || 0,
      workpiece_weight: inputObj.inputValue7 || 0,
      workpiece_heart_length: inputObj.inputValue8 || 0,
    };
    let params = {};
    if (value === 'one') {
      // params = {...paramsPublic, robotIndex: 0, tongs_heart_length: inputObj.inputValue4, workpiece_heart_length: inputObj.inputValue8};
      params = {...paramsPublic, robotIndex: '1'};
    } else {
      // params = {...paramsPublic, robotIndex: 1, tongs_j5_length: inputObj.inputValue4_1, tongs_j6_length: inputObj.inputValue4_2, workpiece_j5_length: inputObj.inputValue8_1, workpiece_j6_length: inputObj.inputValue8_2 };
      params = {...paramsPublic, robotIndex: '0' };
    }

    const res = await dispatch(getCalculartorAction({user: {token: null, user: null}, tenant: {}, calculatorVal: selectValue, params: params}));

    if (value === 'one') {
      // setRatedObj({...ratedObj, ratedValue1: res[0]['specifiedInertia'], ratedValue2: res[0]['specifiedWeight']});
      setActualObj({...actualObj, actualValue1: res[0]['inertia'], actualValue2: res[0]['weight'] });
    } else {
      // setRatedObj({...ratedObj, ratedValue3: res[0]['specifiedJ5'], ratedValue4: res[0]['specifiedJ6'], ratedValue5: res[0]['specifiedWeight']});
      setActualObj({...actualObj, actualValue3: res[0]['J5_moment'], actualValue4: res[0]['J6_Inertia'], actualValue5: res[0]['weight']});
    }
  };

  // console.log('-------------ceilceil');
  // console.log(ceil(50, 3));
  return (
    <div className='calculatorContainer'>
      {/* 面包屑 */}
      {deviceType==='computer'&&<Breadcrumbs style={{ height: '30px' }} separator=">" maxItems={3}>
        <Link
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
          color='textPrimary'
          to={'/robot'}
          component={RouteLink}
        >
          机器人
        </Link>
        <Typography color="textPrimary">
          产品惯量计算
        </Typography>
      </Breadcrumbs>}
      {/* 计算器content */}
      <Dialog maxWidth="xs" fullWidth open={showPop} onClose={() => {setShowPop(false)}}>
        <DialogTitle>选择机器人型号</DialogTitle>
        <DialogContent style={{minHeight: '200px',flexGrow:1}}>
        <List dense className='calculatorList scrollBar'>
        {robotList.map((value, index) => {
                      return (
                        <ListItem key={index} onClick={handleSelect} className={selectValue === value.model ? 'calculatorListItem active' : 'calculatorListItem'}>
                          <ListItemText>
                            {value.model}
                          </ListItemText>
                          <ListItemSecondaryAction>
                            <CheckIcon fontSize='small' className={selectValue === value.model ? 'calculatorIcon active' : 'calculatorIcon'} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                    </List>
        </DialogContent>
        <DialogActions style={{height:'58px',padding:'0px',borderTop:'1px solid gray',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Box style={{fontSize:'16px',padding:'10px',width:'50%',display:'flex',justifyContent:"center",alignItems:'center'}} onClick={()=>{setShowPop(false)}}>取消</Box>
          <Box style={{width:'1px',height:'100%',background:'gray'}}></Box>
          <Box  style={{fontSize:'16px',padding:'10px',width:'50%',display:'flex',justifyContent:"center",alignItems:'center'}}onClick={()=>{setShowPop(false)}}>确定</Box>
        </DialogActions>
      </Dialog>
      <Box className={classes.calPages}>
      {deviceType==='computer'&&<Title name={'产品惯量计算'}></Title>}
        <Box className={classes.calwbg}>
          {/* 响应式布局容器 */}
          <Grid container spacing={3} className='calculatorGrid'>
            {/* 第一列 */}
            <Grid item xs={ deviceType==='computer'?4:12} >
              <Tabs
                value={value}
                onChange={handleChange}
                className='calculatorTab'
                indicatorColor="secondary"
                textColor="secondary"
              >
                <Tab value='one' label="水平多关节机器人" />
                <Tab value='two' label="垂直多关节机器人" />
              </Tabs>
              <TabPanel value={value} index='one'>
                <Box className='calculatorBox'> 
                  <Typography className='calculatorTitle'>选择机器人型号</Typography>
                  {deviceType==='mobile'&&<Box onClick={()=>{
                    setShowPop(true)
                  }} style={{display:'flex',flexDirection:'row',alignItems:"center",justifyContent:"space-between"}}>
                    <Box style={{color:'gray',fontSize:'16px'}}>{selectValue?selectValue:'请选择'}</Box>
                    <img src='/images/right.svg' style={{width:'30px',height:'30px'}} />
                    </Box>}
                  {deviceType==='computer'&&<List dense className='calculatorList scrollBar'>
                    {robotList.map((value, index) => {
                      return (
                        <ListItem key={index} onClick={handleSelect} className={selectValue === value.model ? 'calculatorListItem active' : 'calculatorListItem'}>
                          <ListItemText>
                            {value.model}
                          </ListItemText>
                          <ListItemSecondaryAction>
                            <CheckIcon fontSize='small' className={selectValue === value.model ? 'calculatorIcon active' : 'calculatorIcon'} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>}
                </Box>
              </TabPanel>
              <TabPanel value={value} index='two'>
                <Box className='calculatorBox'> 
                  <Typography className='calculatorTitle'>选择机器人型号</Typography>
                  {deviceType==='mobile'&&<Box onClick={()=>{
                    setShowPop(true)
                  }} style={{display:'flex',flexDirection:'row',alignItems:"center",justifyContent:"space-between"}}>
                    <Box style={{color:'gray',fontSize:'16px'}}>{selectValue?selectValue:'请选择'}</Box>
                    <img src='/images/right.svg' style={{width:'30px',height:'30px'}} />
                    </Box>}
                  {deviceType==='computer'&&<List dense className='calculatorList scrollBar'>
                    {robotList.map((value, index) => {
                      return (
                        <ListItem key={index} onClick={handleSelect} className={selectValue === value.model ? 'calculatorListItem active' : 'calculatorListItem'}>
                          <ListItemText> 
                            {value.model}
                          </ListItemText>
                          <ListItemSecondaryAction>
                            <CheckIcon fontSize='small' className={selectValue === value.model ? 'calculatorIcon active' : 'calculatorIcon'} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>}
                </Box>
              </TabPanel>
            </Grid>
            {/* 第二列 */}
            <Grid item xs={deviceType==='computer'?4:12} >
              <Box className='calculatorBox mt'>
                <Typography className='calculatorTitle'>说明</Typography>
                <Box className='calculatorImageBox'>
                  <ButtonBase
                    focusRipple
                    className={classes.imageButton}
                    focusVisibleClassName={classes.focusVisible}
                    onClick={handleClickOpen}
                  >
                    <img className='imageSrc' src={activeValue.url} ></img>
                    <span className={classes.imageBackdrop}></span>
                    <SearchIcon fontSize='small' className='calculatorIcon2' />
                  </ButtonBase>
                  {/* 图片弹框 */}
                  <Dialog
                    open={open}
                    onClose={handleClose}
                  >
                    <DialogContent>
                      <img className='dialogImage' src={activeValue.url} ></img>
                    </DialogContent>
                  </Dialog>
                </Box>
                <Typography className='calculatorTitle'>填写抓手数据</Typography>
                <Box className='marginBox'>
                  {/* onChange={(e) => {setInputValue1(Number(e.target.value));}}
                    value={inputValue1} */}
                  <TextField
                    label="长度"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue1}
                    onChange={(e) => {setInputObj({...inputObj, inputValue1: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="宽度"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue2}
                    onChange={(e) => {setInputObj({...inputObj, inputValue2: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="重量"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue3}
                    onChange={(e) => {setInputObj({...inputObj, inputValue3: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">KG</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="抓手重心离轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue4}
                    onChange={(e) => {setInputObj({...inputObj, inputValue4: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                {/* {activeResult === 'two' && <Box className='marginBox'>
                  <TextField
                    label="抓手重心离J5轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue4_1}
                    onChange={(e) => {setInputObj({...inputObj, inputValue4_1: Number(e.target.value)});}}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>}
                {activeResult === 'two' && <Box className='marginBox'>
                  <TextField
                    label="抓手重心离J6轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue4_2}
                    onChange={(e) => {setInputObj({...inputObj, inputValue4_2: Number(e.target.value)});}}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>} */}
                <Typography className='calculatorTitle'>填写工件数据</Typography>
                <Box className='marginBox'>
                  <TextField
                    label="长度"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue5}
                    onChange={(e) => {setInputObj({...inputObj, inputValue5: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="宽度"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue6}
                    onChange={(e) => {setInputObj({...inputObj, inputValue6: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="重量"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue7}
                    onChange={(e) => {setInputObj({...inputObj, inputValue7: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">KG</InputAdornment>,
                    }}
                  />
                </Box>
                <Box className='marginBox'>
                  <TextField
                    label="工件重心离轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue8}
                    onChange={(e) => {setInputObj({...inputObj, inputValue8: Number(e.target.value)});}}
                    InputProps={{
                      inputProps: {min: 0},
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>
                {/* {activeResult === 'two' && <Box className='marginBox'>
                  <TextField
                    label="工件重心离J5轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue8_1}
                    onChange={(e) => {setInputObj({...inputObj, inputValue8_1: Number(e.target.value)});}}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>}
                {activeResult === 'two' && <Box className='marginBox'>
                  <TextField
                    label="工件重心离J6轴的距离"
                    size='small'
                    color='secondary'
                    variant='outlined'
                    type='number'
                    className='inputWidth'
                    value={inputObj.inputValue8_2}
                    onChange={(e) => {setInputObj({...inputObj, inputValue8_2: Number(e.target.value)});}}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />
                </Box>} */}
                {/* 计算按钮 */}
                <Box className='marginBox tac'>
                  {/* 未选择具体型号也可以计算 */}
                  <Button variant='contained' color='secondary' className='submitButton' onClick={handleSubmit} disableElevation>开始计算</Button>
                </Box>
              </Box>
            </Grid>
            {/* 第三列 */}
            <Grid item xs={deviceType==='computer'?4:12} >
              <Box className='calculatorBox mt'>
                <Typography className='calculatorTitle'>计算结果</Typography>
                {activeResult === 'one' && <Grid className='resultGrid' alignItems='flex-end' container spacing={1}>
                  {/* 标题 */}
                  <Grid item xs={3}></Grid>
                  <Grid item xs={4}>
                    <Typography className='calculatorHead'>额定</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='calculatorHead'>结果</Typography>
                  </Grid>
                  {/* 第一行 */}
                  <Grid item xs={3}>
                    <Typography className='calculatorText'>水平惯量：</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className='resultText rated unit1'>{ratedObj.ratedValue1}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='resultText result unit1'>{actualObj.actualValue1}</Typography>
                  </Grid>
                  {/* 第二行 */}
                  <Grid item xs={3}>
                    <Typography className='calculatorText'>可搬运重量：</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className='resultText rated unit2'>{ratedObj.ratedValue2}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='resultText result unit2'>{actualObj.actualValue2}</Typography>
                  </Grid>
                </Grid>}
                {activeResult === 'two' && <Grid className='resultGrid' alignItems='flex-end' container spacing={1}>
                  {/* 标题 */}
                  <Grid item xs={3}></Grid>
                  <Grid item xs={4}>
                    <Typography className='calculatorHead'>额定</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='calculatorHead'>结果</Typography>
                  </Grid>
                  {/* 第一行 */}
                  <Grid item xs={3}>
                    <Typography className='calculatorText'>J5轴力矩：</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className='resultText rated unit3'>{ratedObj.ratedValue3}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='resultText result unit3'>{actualObj.actualValue3}</Typography>
                  </Grid>
                  {/* 第二行 */}
                  <Grid item xs={3}>
                    <Typography className='calculatorText'>J6轴惯量：</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className='resultText rated unit1'>{ratedObj.ratedValue4}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='resultText result unit1'>{actualObj.actualValue4}</Typography>
                  </Grid>
                  {/* 第三行 */}
                  <Grid item xs={3}>
                    <Typography className='calculatorText'>可搬运重量：</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className='resultText rated unit2'>{ratedObj.ratedValue5}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography className='resultText result unit2'>{actualObj.actualValue5}</Typography>
                  </Grid>
                </Grid>}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default function RobotCalculatorContainer(props) {
  return (<RobotCalculatorView {...props}/>);
}